import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { EmptyMessage } from "../components/EmptyMessage";
import { selectUserInfo } from "../features/users/userInfoSlice";
import ClientInformationForms from "../pages/client/dashboard/ClientInformationForms";
import EditUser from "../pages/client/dashboard/editUser";
import Subcribe from "../pages/client/dashboard/subcribe";
import AddUser from "../pages/client/dashboard/UserInvitation";
import Users from "../pages/client/dashboard/users";
import AddWebsites from "../pages/client/websites/AddWebsites";
import ComSupports from "../pages/client/websites/ComSupports";
import Concurrents from "../pages/client/websites/Concurrents";
import MesConnextions from "../pages/client/websites/MesConnextions";
import Quiz from "../pages/client/websites/Quiz";

/**
 * Get view by pathname url
 * @returns {React.Component | JSX.Element}
 */
export function usePathUrlMatcher() {
  const { location, push, goBack } = useHistory()
  const userContext = useSelector(selectUserInfo);
  const isUrlParam = location.pathname.includes('/users/edit/')

  switch (location.pathname) {
    case '/': return push('/visibility');
    case '/account': return <ClientInformationForms />;
    case '/account/forfait':
      if (userContext?.user?.admin) return <Subcribe />
      return push('/account');
    case '/account/users':
      if (userContext?.user?.admin) return <Users />
      return push('/account');
    case isUrlParam ? location.pathname : '/account/users/edit/:id':
      if (userContext?.user?.admin) return <EditUser />
      return push('/account');
    case '/account/users/add':
      if (userContext?.user?.admin) return <AddUser />
      return push('/account');
    case '/websites':
      if (userContext?.user?.admin) return <AddWebsites />
      return goBack()
    case '/websites/concurrents':
      if (userContext?.user?.admin) return <Concurrents />;
      return goBack()
    case '/websites/com-supports':
      if (userContext?.user?.admin) return <ComSupports />;
      return goBack()
    case '/websites/connexions':
      if (userContext?.user?.admin) return <MesConnextions />;
      return goBack()
    case '/websites/quiz':
      if (userContext?.user?.admin) return <Quiz />;
      return goBack()
    default: return <div className="min-h-[500px] flex items-center justify-center">
      <EmptyMessage title="Cette ressource n'existe pas." message="Suivez la navigation pour acceder au contenu existant de l'application." />
    </div>
  }
}